/**
 * @desc 參數名称查询参数值(只查询已启用的)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  params: API.basics.sysGlobalParamFacadeImpl.byEnabledKeyName.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/sysGlobalParam/byEnabledKeyName`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
